import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Tailwind class merger - de-duplicates conflicting utility classes.
 * Standard shadcn/ui helper used by every primitive & screen.
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
